<template>
  <div v-if="dataDeliveryMethods.length || dataExcludedMethods.length">
    <h1 v-if="dataDeliveryMethods.length" class="subtitle has-text-weight-bold has-text-primary is-size-4">
          Opções de Envio ({{ dataDeliveryMethods.length }})
      </h1>
    <sc-table v-if="dataDeliveryMethods.length" :data="dataDeliveryMethods">
      <template slot-scope="props">
        <sc-table-column field="logo" label="" width="120">
          <figure class="image">
            <img :src="props.row.logo" />
          </figure>
        </sc-table-column>
        <sc-table-column field="id" label="#ID" width="40">
          {{ props.row.id }}
        </sc-table-column>
        <sc-table-column field="metodo" label="Métodos de entrega">
          {{ props.row.metodo }}
        </sc-table-column>
        <sc-table-column field="type" label="Tipo">
          {{ props.row.type }}
        </sc-table-column>
        <sc-table-column field="status" label="Status">
          {{ props.row.status }}
        </sc-table-column>
        <sc-table-column field="estimate" label="Frete exibido">
          {{ props.row.final_shipping_cost | currency }}
        </sc-table-column>
        <sc-table-column field="estimate" label="Prazo de entrega">
          {{ props.row.estimate }} dias
        </sc-table-column>
        <sc-table-column field="cost" label="Custo de envio">
          R$: {{ props.row.cost | currency }}
        </sc-table-column>
        <sc-table-column field="" label="">
           <a :href="'javascript:void(0)'"
            @click="props.row.getDetail(props.row.quoteFreight.id, props.row.delivery_method, props.row.fields, props.row.status, props.row.id)" class="button is-primary">
            Cotação Detalhada</a>
        </sc-table-column>
      </template>
    </sc-table>
    <br />
    <h1 v-if="dataExcludedMethods.length" class="subtitle has-text-weight-bold has-text-primary is-size-4">
          Opções nāo disponiveis ({{ dataExcludedMethods.length }})
      </h1>
    <sc-table v-if="dataExcludedMethods.length" :data="dataExcludedMethods">
      <template slot-scope="props">
        <sc-table-column field="logo" label="" width="120">
          <figure class="image">
            <img :src="props.row.logo" />
          </figure>
        </sc-table-column>
        <sc-table-column field="metodo" label="Métodos de entrega">
          {{ props.row.metodo }}
        </sc-table-column>
        <sc-table-column field="motivo" label="Motivo" :centered="false">
          {{ props.row.motivo }}
        </sc-table-column>
      </template>
    </sc-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScTable,
  ScTableColumn,
} from '@intelipost-js/secure-components';
import EnumStatusList from '../../enums/EnumContractStatus';

const {
  mapState,
} = createNamespacedHelpers('quote/freightQuote');

export default {
  name: 'sc-quote-test-return',
  props: {
    fields: Object,
  },
  computed: {
    ...mapState([
      'quoteFreight',
      'contract_list',
      'logistic_contract_mode',
    ]),
    dataExcludedMethods() {
      return this.quoteFreight.excluded_methods.map(q => ({
        metodo: q.name,
        motivo: q.delivery_restrictions[0],
        logo: q.logo_url,
      }));
    },
    dataDeliveryMethods() {
      return this.quoteFreight.logistic_provider.delivery_methods.map(d => ({
        id: d.logistic_contract_id,
        metodo: d.name,
        type: d.type.label,
        status: this.getStatus(d.logistic_contract_id),
        logo: d.logo_url,
        estimate: d.delivery_estimate_business_days,
        final_shipping_cost: d.final_shipping_cost,
        cost: d.final_shipping_cost,
        logicContract: this.logistic_contract_mode,
        quoteFreight: this.quoteFreight,
        delivery_method: d,
        getDetail: this.getDetail,
        fields: this.fields,
      }));
    },
  },
  methods: {
    getStatus(contract_id) {
      let status;
      Object.keys(this.contract_list).forEach((key) => {
        EnumStatusList.forEach((el) => {
          this.contract_list[key][el.default_name].forEach((contract) => {
            if (contract.id === contract_id) {
              status = el.name;
            }
          });
        });
      });
      return status;
    },
    getDetail(quoteFreightId, dm, fields, status, contract_id) {
      const id = Math.floor(Date.now() / 1000);
      let logicContract = this.logistic_contract_mode;
      const obj = {
        content: {
          origin_zip_code: fields.origin_zip_code,
          destination_zip_code: fields.destination_zip_code,
          delivery_options: [dm],
          volumes: fields.volumes.map((v) => {
            const fixParams = {
              volume_type: 'BOX',
              product_category: null,
              description: null,
              sku_groups_ids: null,
            };
            return Object.assign(v, fixParams);
          }),
        },
      };
      if (status) {
        logicContract = status.toLowerCase() === 'rascunho';
      }
      sessionStorage.setItem(id, JSON.stringify(obj));
      window.open(`/ng#/recote/${quoteFreightId}/${dm.id}?msg=false&url=${window.location.href}&logisticContractMode=${logicContract}&contractId=${contract_id}`, '_blank');
    },
  },
  components: {
    ScTable,
    ScTableColumn,
  },
};
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-quote-test-return/ScQuoteTestReturn.vue?4d86556e